







































































import { Component } from "vue-property-decorator";
import SumInput from "@/components/app/SumInput.vue";
import { BaseOperationPropertyVueFS } from "@/extensions/operation/BaseOperationPropertyVueFS";
import { DeclarationPropertiesTypes } from "fs-pb-vue2/data/enums/declarationPropertiesTypes";
import { Prop, Watch } from "vue-property-decorator";
import PhoneSelect from "./PhoneSelect.vue";
import { PhoneFormat } from "fs-pb-vue2/data/phoneFormat";

@Component({
  components: { SumInput, PhoneSelect }
})
export default class TextProperty extends BaseOperationPropertyVueFS {

}
